import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const SampleBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="Sample"
      sectionDisplayName="Sample Section"
      backRoute="/sections/sample"
    />
  );
};

export default SampleBundleReceiptEntry;
